<template>
  <div v-hotkey="keymap">
    <div class="accordion-header">
      <b-button class="btn-sm accordion-toggle-btn" block @click="togglePaneOpen($event)" v-bind:class="{ active: paneOpen }">
        <div>{{hebrew ? 'פיענוח ידני' : 'Manual expansion'}}</div>
        <div v-if="!paneOpen"><i-caret-up></i-caret-up></div>
        <div v-else><i-caret-down></i-caret-down></div>
      </b-button>
    </div>
    <div v-show="paneOpen" class="mb-2 pt-2">
      <div class="manual-nikud-box-container" dir="rtl">
        <div class="word-letters-screen" v-bind:class="{'warning-screen': noTextWarning, 'disabled-screen': !localCurrentWordWasAnAbbreviation}">
          <div v-show="currentLetterNotSep" class="ml-auto">
            <b-input v-bind:disabled="!localCurrentWordWasAnAbbreviation" class="manual-input" v-model="lettersOfCurrentWord" />
          </div>
          <div v-show="currentLetterNotSep && localUserDictionary.entryPresent[localCurrentWord.chosenWordString]"
               @click="removeFromUserDictionary(localCurrentWord.chosenWordString)" class="dictionary-button"><i-star :solid="true"></i-star>
          </div>
          <div
            v-show="lettersOfCurrentWord.length && currentLetterNotSep && !(localUserDictionary.entryPresent[localCurrentWord.chosenWordString]) /* && localCurrentWord && localCurrentWord.altered */"
            @click.stop="tryToAddToUserDictionary" class="dictionary-button">
            <i-star></i-star>
          </div>
          <div title="חזור לראשי התיבות" v-show="lettersOfCurrentWord.length && currentLetterNotSep" @click="clearNikudClicked" class="dictionary-button close-hover mr-0">
            <i-times></i-times>
          </div>
        </div>
      </div>
      <p v-show="noTextWarning" style="color: red; font-size: 14px;" class="mb-0 "
        v-bind:class="{'mr-2': hebrew, 'ml-2' : !hebrew}">
        {{hebrew ? '*יש להזין טקסט' : '*Text is required'}}
      </p>
      <b-button id="manual-apply-button" class="mt-2 mr-2"
      v-bind:class="{'mr-2': hebrew, 'ml-2' : !hebrew}"
        @click="useNewNikud" 
        v-bind:disabled="!localCurrentWordWasAnAbbreviation"
        variant="primary">{{hebrew ? 'השתמש' : 'Apply'}}</b-button><br />
      <div v-show="!noTextWarning" style="height: 20px;" />
      <a href="#"
        class="clickable-link"
        @click="showApplyToAllPopup = true">{{hebrew ? 'החל על כל הטקסט' : 'Apply to entire text'}}</a>
    </div>
    <b-modal id="apply-to-all-popup"
             v-model="showApplyToAllPopup"
             :ok-title="hebrew ? 'החל' : 'Apply'"
             :cancel-title="hebrew ? 'ביטול' : 'Cancel'"
             footer-class="apply-to-all-footer"
             centered
             @ok="applyToEntireText"
             size="sm"
    >
      <template slot="modal-header"><div>{{hebrew ? 'החל על כל הטקסט' : 'Apply to entire text'}}</div></template>
      <b-form-radio id="doBelow" value="below" v-model="applyToAllMode">{{hebrew ? ' החל אפשרות זו ממילה זו והלאה' : 'Apply for this word forward'}}</b-form-radio>
      <b-form-radio id="doUnedited" value="unedited" v-model="applyToAllMode">{{hebrew ? ' החל רק על מילים שלא נערכו' : 'Apply to all unedited words'}}</b-form-radio>
      <b-form-radio id="doAll" value="all" v-model="applyToAllMode">{{hebrew ? ' החל על כל הטקסט' : 'Apply to entire text'}}</b-form-radio>
    </b-modal>
    <div class="manual-nikud-account-needed-popup click-only-here" v-show="showAccountNeededPopup">
      {{hebrew ? 'כדי להוסיף מילה למאגר, יש להתחבר לחשבון האישי.' : 'To add an abbreviation to your personal list, please log in to your account.'}}
    </div>
  </div>
</template>

<script>

import {processNikudSingleLineIntoStructure} from 'shared/js/wordBreakup'
import nikudMixins from '@/mixins/nikudMixins'
import manualNikudPaneKeyMap from '@/mixins/manualNikudPaneKeyMap'
import {RunStates} from '@/store/runStates'
import $ from 'jquery'
import serviceMixins from '@/mixins/serviceMixins'
import navigationMixins from '@/mixins/navigationMixins'
import resultsIntegrationMixins from '@/mixins/resultsIntegrationMixins'
import wordMutatingMixins from '@/mixins/wordMutatingMixins'
import {LETTER, /* METEG, (its use is now disabled) */ stringWithoutNikud} from 'shared/js/commonHebrew'
// import {getChosenWordString, getStandardLetterArray} from '@/js/letterOperations'
import conditionalOptions from 'shared/js/conditionalOptions'
import styleGlobals from 'shared/js/forTextPanel/styleGlobals'
import {generateAbbreviationDisplayText} from '@/js/abbreviationDisplayText'

export default {
  name: 'ManualNikudPane',
  mixins: [
    nikudMixins, /* for the direct use of: localCurrentWordIndex, localCurrentLetterIndex, 
                      localLetterAddingMode (here AND KeyMap),
                      localCurrentWord (here AND KeyMap), currentLetterNotSep (here AND KeyMap),
                      modalOpen() (in keymap), removeFromUserDictionary(), callForNewNikud(), 
                      showChangedNikudMessage(), and display() ...
                    ...and for the use, as a changeAllAlikeWordsToNewNikud() dependency, of: getAllAlikeWordsToChange()... */
    resultsIntegrationMixins, // for finishEditingWordGroup()
    wordMutatingMixins, /* for the direct use of: rewriteWordOrWordsInWorkingArrayMethod() and 
                          changeAllAlikeWordsToNewNikud() ...
                        ...& b/c (now) whoever uses resultsIntegrationMixins needs wordMutatingMixins too */
    manualNikudPaneKeyMap, // for keymap
    serviceMixins, // for gtag()
    navigationMixins // for moveToNextWord() and moveToPreviousWord()
  ],
  props: ['subPanesStatus', 'modesObj', 'editNikudProps'],
  data () {
    return {
      noTextWarning: false,
      useOnAllText: false,
      lettersOfCurrentWord: '',
      applyToAllMode: 'below',
      showApplyToAllPopup: false,
      workingWord: null, // for 'redoing nikud' of multiple words
      waitingToRedoNikud: false, // ditto
      workingIndices: [], // ditto
      addToUserDictionary: false,
      showAccountNeededPopup: false
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    localCurrentWordWasAnAbbreviation () {
      return this.localCurrentWord && this.localCurrentWord.wasAnAbbreviation
    },
    conditionalDictStringsMatchingCurrentWord () {
      const userDictPosQuery // copied from resultIntegrationMixins
        = this.localUserDictionary.lettersMap[this.localCurrentWord.originalWord]
      return userDictPosQuery ?
        userDictPosQuery.filter((dictString) => {
          const optionObj = conditionalOptions.optionObjFromDictString(dictString)
          return this.localCurrentWord.chosenWordString === optionObj.displayText
            && optionObj.conditions.length && conditionalOptions.testConditions(optionObj.conditions,
              this.$store.state.allWorkingNikud.wordsArray, this.localCurrentWordIndex)
        }) : []
    },
    paneOpen () {
      return this.subPanesStatus.manualOpen
    },
    localOptionsPaneOpen () {
      return this.subPanesStatus.optionsOpen
    },
    localnakdanApiState: function () {
      return this.$store.state.nakdanApiState
    },
    nakdanRunning () {
      return this.$store.state.nakdanApiState === RunStates.RUNNING
    },
    localCurrentWordSeps () {
      return this.localCurrentWord ? (this.localCurrentWord.sepBefore + this.localCurrentWord.sepAfter) : ''
    },
    localWordMutationCount () {
      return this.modesObj.wordMutationCount
    }
  },
  watch: {
    lettersOfCurrentWord () {
      this.noTextWarning = false
    },
    localCurrentWordIndex: function (newLocalCurrentWordIndex) {
      if (newLocalCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */ )
    },
    localWordMutationCount: function () {
      if (this.localCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */)
    },
    localCurrentWordSeps: function () {
      if (this.localCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */)
    },
    localnakdanApiState: function (newLocalnakdanApiState) {
      if (this.editNikudProps && !(this.editNikudProps.showEditNikud) && newLocalnakdanApiState === RunStates.COMPLETE) {
        /* if (this.nakdanCallType === 'redo-nikud') { 
          this.finishRedoingNikud() 
        } else { */ this.finishEditingWordGroup(); this.moveAfterEditingWordGroupIfNeeded() /* } */
      }
    }
  },
  methods: {
    togglePaneOpen () {
      this.subPanesStatus.manualOpen = !(this.subPanesStatus.manualOpen)
    },
    changeCurrentLetterIndex (le) {
      this.$store.commit('SET_CURRENT_LETTER_INDEX', le)
    },
    initLettersOfCurrentWord (mode /* , currentLetterMode = 'reset-unless-clearing-nikud' */ ) {
      if (this.localCurrentWordWasAnAbbreviation) {
        const fieldToUse = (mode === 'clear-nikud') ? 'originalWord' : 'chosenWordString'
        this.lettersOfCurrentWord = this.localCurrentWord[fieldToUse]
                                      .replace(/.ֽ/g, '').replace(new RegExp(styleGlobals.SPACE_SUBSTITUTE, 'g'), ' ')
                                      .slice((mode === 'clear-nikud') ? 0 : 1) // skip concatenating (non-breaking) space
      } else this.lettersOfCurrentWord = ''
      /*
      if ((mode === 'to-chosen-word-with-nikud') && (currentLetterMode !== 'leave-current-letter')) {
        this.changeCurrentLetterIndex(-1)
        setTimeout(() => {
          if (this.localCurrentLetterIndex === -1) this.changeCurrentLetterIndex(this.localCurrentWord.sepBefore.length)
        }, 3)
      } */
    },
    clearNikudClicked () {
      this.initLettersOfCurrentWord('clear-nikud')
      // this.useNewNikud()
    },
    nikudOptionClicked (optionText) {
      var lettersOfCurrentWord = [] // re-create the array so the change will be reactive
      this.lettersOfCurrentWord.forEach(letter => {
        lettersOfCurrentWord.push(letter)
      })
      lettersOfCurrentWord[this.localCurrentLetterIndex] = optionText
      this.lettersOfCurrentWord = lettersOfCurrentWord
      this.useNewNikud()
    },
    moveToNextLetter (mode = 'manual') {
      if (this.localCurrentLetterIndex < (this.lettersOfCurrentWord.length - 1)) {
        this.changeCurrentLetterIndex(this.localCurrentLetterIndex + 1)
        if (this.display(this.lettersOfCurrentWord[this.localCurrentLetterIndex]) === '' ) {
          this.moveToNextLetter(mode)
        }
      } else this.moveToNextWord('manual')
    },
    moveToPreviousLetter () {
      if (this.localCurrentLetterIndex > 0) {
        this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        if (this.display(this.lettersOfCurrentWord[this.localCurrentLetterIndex]) === '') {
          this.moveToPreviousLetter()
        }
      } else this.moveToPreviousWord('manual')
    },
    processAddingOrDeletingCharacter (charAddedOrDeleted) {
      // new policy - only call the API if there is a "change in WORD(S)"
      if (Object.values(LETTER).includes(charAddedOrDeleted[0])) { // [0] b/c there may be more, such as a meteg
        this.callForNewNikud(this.workingWord)
      } else {
        // get the word/sep breaks from our own code
        let stripped = stringWithoutNikud(this.workingIndices.map((i) => {
          const w = this.$store.state.allWorkingNikud.wordsArray[i]
          return w.sepBefore + w.chosenWordString + w.sepAfter
        }).join('').trim())
        const workingWordOldStructure = processNikudSingleLineIntoStructure(stripped)
        stripped = stringWithoutNikud(this.workingWord.trim())
        const workingWordNewStructure = processNikudSingleLineIntoStructure(stripped)
        // console.log('workingWordOldStructure:')
        // console.log(workingWordOldStructure)
        // console.log('workingWordNewStructure:')
        // console.log(workingWordNewStructure)
        const wordsInOldStructure = workingWordOldStructure.filter(seg => !(seg.sep)).length
        const wordsInNewStructure = workingWordNewStructure.filter(seg => !(seg.sep)).length
        // this.waitingToRedoNikud = true
        if (wordsInNewStructure !== wordsInOldStructure) {
          this.callForNewNikud(this.workingWord)
        } else {
          this.$store.commit('SET_NAKDAN_RESULTS', workingWordNewStructure)
          setTimeout(() => {
            this.finishEditingWordGroup('use-existing-options')
            this.moveAfterEditingWordGroupIfNeeded()
          }, 1)
        }
      }
      // end of "new policy" code
    },
    /* the following two methods are currently deactivated (and would have to be re-done anyway)
    deleteCurrentLetter () {
      if (this.localCurrentLetterIndex < this.localCurrentWord.sepBefore.length) {
        const newSepBefore = this.localCurrentWord.sepBefore.slice(0, this.localCurrentLetterIndex)
              + this.localCurrentWord.sepBefore.slice(this.localCurrentLetterIndex + 1)
        if (newSepBefore === '' && this.localCurrentWordIndex > 0) {
          const deletedChar = this.localCurrentWord.sepBefore[this.localCurrentLetterIndex]
          const prevWord = this.$store.state.allWorkingNikud.wordsArray[this.localCurrentWordIndex - 1]
          const prevWordText = prevWord.sepBefore + prevWord.chosenWordString + prevWord.sepAfter
          this.workingWord = prevWordText + newSepBefore + this.localCurrentWord.chosenWordString + this.localCurrentWord.sepAfter
          this.workingIndices = [this.localCurrentWordIndex - 1, this.localCurrentWordIndex]
          this.processAddingOrDeletingCharacter(deletedChar)
          this.moveToPreviousWord('manual')
        } else {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: {
                altered: true, 
                choiceType: 'manual',
                manualNikud: this.localCurrentWord.chosenWordString,
                sepBefore: newSepBefore
              }
            }
          })
          if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        }
      } else if (this.localCurrentLetterIndex > (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length - 1)) {
        const newSepAfter = this.localCurrentWord.sepAfter.slice(0, this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length))
                + this.localCurrentWord.sepAfter.slice(this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length) + 1)
        if (newSepAfter === '' && this.localCurrentWordIndex < (this.$store.state.allWorkingNikud.wordsArray.length - 1)) {
          const deletedChar = this.localCurrentWord.sepAfter[this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length)]
          const nextWord = this.$store.state.allWorkingNikud.wordsArray[this.localCurrentWordIndex + 1]
          const nextWordText = nextWord.sepBefore + nextWord.chosenWordString + nextWord.sepAfter
          this.workingWord = this.localCurrentWord.sepBefore + this.localCurrentWord.chosenWordString + newSepAfter + nextWordText
          this.workingIndices = [this.localCurrentWordIndex, this.localCurrentWordIndex + 1]
          this.processAddingOrDeletingCharacter(deletedChar)
        } else {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: {
                altered: true, 
                choiceType: 'manual',
                manualNikud: this.localCurrentWord.chosenWordString,
                sepAfter: newSepAfter
              }
            }
          })
          if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        }
      } else {
        const deletedLetter = this.lettersOfCurrentWord[this.localCurrentLetterIndex]
        var newWord = this.lettersOfCurrentWord.slice(this.localCurrentWord.sepBefore.length, this.localCurrentLetterIndex).join('')
          + this.lettersOfCurrentWord.slice(this.localCurrentLetterIndex + 1, this.lettersOfCurrentWord.length - this.localCurrentWord.sepAfter.length).join('')
        this.rewriteWordOrWordsInWorkingArrayMethod({
          contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
          newWordContainer: {
            index: this.localCurrentWordIndex, changes: { 
              altered: true, 
              manualNikud: newWord,
              choiceType: 'manual' 
            }
          }
        })
        this.workingWord = this.localCurrentWord.sepBefore + newWord + this.localCurrentWord.sepAfter
        this.workingIndices = [this.localCurrentWordIndex]
        this.processAddingOrDeletingCharacter(deletedLetter)
        if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
      }
      // this.initLettersOfCurrentWord()
      this.modesObj.letterAddingMode = false
    },
    backspaceCurrentLetter () {
      const currentLetterString = this.lettersOfCurrentWord[this.localCurrentLetterIndex]
      if (currentLetterString.replace(METEG, '') === stringWithoutNikud(currentLetterString)) {
        this.deleteCurrentLetter()
      } else this.changeCurrentLetter('CLEAR')
      this.modesObj.letterAddingMode = false
    }, */
    addCharacter (charToAdd) {
      if (this.localCurrentWordIndex === -1) return
      // (addCharacter mode is deactivated anyway, but this next line CERTAINLY makes no sense in abbreviation:)
      // if (this.$store.state.postSubmissionOptions.showAims && 'אהוי'.includes(charToAdd)) charToAdd += METEG
      this.workingWord = this.lettersOfCurrentWord.slice(0, this.localCurrentLetterIndex + 1).join('') + charToAdd
        + this.lettersOfCurrentWord.slice(this.localCurrentLetterIndex + 1).join('')
      this.workingIndices = [this.localCurrentWordIndex]
      this.processAddingOrDeletingCharacter(charToAdd)
      this.moveToNextLetter('manual')
      setTimeout(() => {
        this.modesObj.letterAddingMode = false
      }, 10)
    },
    useNewNikud () {
      if (this.lettersOfCurrentWord.length === 0) {
        this.noTextWarning = true
        return
      }
      const currentDisplayText = generateAbbreviationDisplayText(this.localCurrentWord.originalWord, this.lettersOfCurrentWord)
      var joined = this.localCurrentWord.sepBefore + currentDisplayText + this.localCurrentWord.sepAfter
      if (joined !== this.localCurrentWord.sepBefore + this.localCurrentWord.chosenWordString + this.localCurrentWord.sepAfter) {
        this.rewriteWordOrWordsInWorkingArrayMethod({
          contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
          newWordContainer: {
            index: this.localCurrentWordIndex, changes: {
              altered: true, 
              choiceType: 'manual',
              manualNikud: joined.slice(this.localCurrentWord.sepBefore.length, joined.length - this.localCurrentWord.sepAfter.length),
              sepBefore: joined.slice(0, this.localCurrentWord.sepBefore.length),
              sepAfter: joined.slice(joined.length - this.localCurrentWord.sepAfter.length)
            }
          }
        })
      }
      if (this.addToUserDictionary) {
        setTimeout(() => { // wait for localCurrentWord to update
          if (!(this.localUserDictionary.entryPresent[this.localCurrentWord.chosenWordString])) {
            this.$store.commit('UPDATE_USER_DICTIONARY', {
              contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
              wordsToAdd: [this.localCurrentWord.chosenWordString]
            })
            this.showAddedToUserDictionaryMessage()
          }
          this.addToUserDictionary = false
        }, 1)
      }
      setTimeout(() => { document.activeElement.blur() }, 500)
    },
    applyToEntireText () {
      // (needs to have already been done! <== ) this.useNewNikud() // in case this fn happens to get called first (or alone) - doing it twice doesn't hurt
      var changed = this.changeAllAlikeWordsToNewNikud()
      this.showChangedNikudMessage(changed)
      // document.getElementById('manual-apply-button').focus()
      document.activeElement.blur()
    },
    tryToAddToUserDictionary () {
      if (this.$store.state.account && this.$store.state.account.isLoggedIn) {
        this.addToUserDictionary = true
        this.useNewNikud()
      } else this.showAccountNeededPopup = true
    }
  },
  mounted: function () {
    $(document).on('click', '.click-only-here', function (e) {
      e.stopPropagation()
    })
    $(document).on('click', () => {
      this.showAccountNeededPopup = false
      this.modesObj.letterAddingMode = false
    })
    $(document).on('keydown', () => {
      if (this.showAccountNeededPopup) this.showAccountNeededPopup = false
    })
    if (this.localCurrentWordIndex > -1) {
      this.initLettersOfCurrentWord('to-chosen-word-with-nikud')
    }
  },
  /* beforeDestroy () {
    this.changeCurrentLetterIndex(-1)
  } */
}
</script>

<style scoped>
.clear-nikud {
  margin: 6px 0 6px 14px;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  display: inline-block;
  float: left;
  border-radius: 2px;
  padding: 0 6px;
}
.clear-nikud:hover, .clear-nikud:focus {
  background: #E3E3E3;
}
.manual-nikud-box-container {
  clear: both;
  margin: 0 8px;
  direction: rtl;
}
.word-letters-screen {
  background-color: white;
  border-radius: 2px;
  border: solid 1px #000000;
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  padding: 0 0 0 4px;
  margin-bottom: 0;
  line-height: 25px;
  overflow: hidden;
}
.letter-on-screen {
  font-family: mft_narkisclassic;
  font-size: 20px;
  cursor: pointer;
  width: 19px;
  display: inline-block;
  height: 28px;
  text-align: center;
  vertical-align: middle;
}
.highlighted-letter {
  background-color: #d6ecff;
}
.editing-cursor {
  color: #d6ecff;
  background-color: #d6ecff;
}
.use-on-all-text, .add-to-user-dictionary {
  margin: 5px;
}
.pane-bottom {
  position: absolute;
  bottom: 10px;
  width: 95%
}
.clear-nikud-x {
  cursor: pointer;
  color: #949494;
}
.normal-line-height {
  line-height: 1.5;
}
.close-hover:hover{
  background: #e3e3e3;
  cursor: pointer;
}
.manual-input {
  border-style: none;
  font-family: Roboto, mft_narkisclassic, sans-serif;
  font-size: 20px;
  line-height: 25px;
  padding: 0 4px 4px;
}
.accordion-toggle-btn:focus{
 box-shadow: none;
  outline: none;
}
.warning-screen {
  border-color: red;
}
.disabled-screen {
  background-color: #f6f6f6;
}
</style>
